import { __decorate } from "tslib";
import { Component, Vue, Watch } from 'vue-property-decorator';
import typo from '@blade-sxp/record-center/lang/index';
import { map } from 'lodash';
import colors from '@/styles/color.scss';
import { Scale } from '@blade/common/utils/auto-scale';
import InputSearch from '@blade-sxp/record-center/components/input-search.vue';
import { getPreDaysParamsIncludeToday } from '@blade-sxp/record-center/utils/date-util';
import { exportCarRecord, getCarData, getParkingLotsOpt } from '@blade-sxp/record-center/api/portrait';
import { getLibraryOption } from '@blade-sxp/its-management/api/detail';
import { permissionlevel } from '@blade/common/constants/role-mode';
import moment from 'moment';
import SecondaryVerification from '@blade/common/pages/Secondary-verification/secondary-verification.vue';
import AuthNewitem from '@blade/common/components/auth/auth-newItem.vue';
import exportButton from '@blade-sxp/record-center/components/buttons/export-button.vue';
import CombinedPicture from '@blade-sxp/portrait-management/components/combined-picture.vue';
import BlurPicture from '@blade/common/components/blur-picture/index.vue';
import datePicker from '@blade/common/components/date-time-select/index.vue';
let default_1 = class default_1 extends Vue {
    // 漏斗图标
    funnelIcon = require('@blade-sxp/task-management/assets/union.png');
    fullSkDialogVisible = false;
    exportLoading = false;
    permissionlevel = permissionlevel;
    initialForm = {
        dates: this.getDafaultDates(),
        vehicleLibNames: [],
        parkingLotNames: [],
        keyword: '',
    };
    tableData = [];
    flowDirections = [];
    form = { ...this.initialForm };
    page = 1;
    size = 10;
    total = 0;
    isLoading = false;
    filterBrand = [];
    filterFlowDirection = [];
    dialogVisible = false;
    vehicleOptions = [];
    parkingOptions = [];
    get formattedData() {
        return map(this.tableData, (item) => {
            const { name, age, status } = item;
            const isFail = status === 'FAIL';
            return isFail
                ? Object.assign(item, {
                    name: name || '-',
                    age: age || '-',
                    status,
                })
                : item;
        });
    }
    get getTableBg() {
        return colors.colorBoxBg;
    }
    /** 是否开启隐私模式 */
    get privacyMode() {
        return localStorage.getItem('privacyMode') === 'true';
    }
    /** 身份照片最大宽度 */
    get idPhotoMaxWidth() {
        return 240 * Scale;
    }
    /** 身份照片最大高度 */
    get idPhotoMaxHeight() {
        return 240 * Scale;
    }
    initI18n() {
        this.filterFlowDirection = [
            { text: String(this.$t('in')), value: 'IN' },
            { text: String(this.$t('out')), value: 'OUT' },
        ];
    }
    // @Watch('form', { deep: true, immediate: false })
    // onConditionUpdate(form: IForm) {
    //   this.page = 1;
    //   this.search();
    // }
    filterTag(value) {
        // console.log(value);
        const { flowDirection } = value;
        this.flowDirections = flowDirection;
        this.onSearch();
    }
    mounted() {
        this.initI18n();
        this.search();
        this.getParkingLotsOptAry();
        this.getLibraryOptionAry();
    }
    getParkingLotsOptAry() {
        getParkingLotsOpt().then((res) => {
            this.parkingOptions = res;
        });
    }
    getLibraryOptionAry() {
        getLibraryOption({ libType: 'AUTO_MOBILE' }).then((res) => {
            // console.log('getLibraryOptionAry', res);
            this.vehicleOptions = res.list;
        });
    }
    // 筛选条件的日期选择
    getDafaultDates() {
        const { dateStart, dateEnd } = getPreDaysParamsIncludeToday(false, 6);
        return [`${dateStart} 00:00:00`, `${dateEnd} 23:59:59`];
    }
    pickerOptions = {
        disabledDate: (date) => moment(date).add(-1, 'days').isSameOrAfter(moment().format('YYYY-MM-DD')),
    };
    // 重置
    reset() {
        this.form = { ...this.initialForm };
        // this.form.dates = ['', ''];
    }
    // 查询
    onSearch() {
        this.page = 1;
        this.dialogVisible = false;
        this.search();
    }
    // 获取入参
    getParams() {
        const [dateStart, dateEnd] = this.form.dates || [];
        const { keyword, vehicleLibNames, parkingLotNames } = this.form;
        const vehicleLib = vehicleLibNames.map((item) => item * 1);
        const parkingLot = parkingLotNames.map((item) => item * 1);
        const dateAry = this.getDafaultDates();
        // console.log(dateAry);
        if (!dateStart && !dateEnd) {
            this.form.dates = dateAry;
            return this.getParams();
        }
        return {
            dateEnd: dateEnd ? `${dateEnd}` : '',
            dateStart: dateStart ? `${dateStart}` : '',
            vehicleLibIds: vehicleLib,
            parkingLotIds: parkingLot,
            keyword,
            flowDirections: this.flowDirections,
            page: this.page,
            size: this.size,
        };
    }
    // 查询
    async search() {
        this.isLoading = true;
        const params = this.getParams();
        try {
            let { list, total } = await getCarData(params);
            this.tableData = list;
            this.total = total;
        }
        catch (error) {
            console.log('search err', error);
        }
        this.isLoading = false;
    }
    // 导出 // 这个暂时废弃、因为没有验证密码
    onExport() {
        const params = this.getParams();
        return exportCarRecord(params);
    }
    handleExport() {
        this.exportLoading = true;
        const params = this.getParams();
        try {
            exportCarRecord(params)
                .then((res) => {
                // console.log(res);
                if (res) {
                    window.location.href = process.env.NODE_ENV === 'development' ? `${res}` : res;
                }
                else {
                    this.exportLoading = false;
                }
            })
                .finally(() => {
                this.exportLoading = false;
            });
        }
        catch (error) {
            console.log('handleExport err');
            this.exportLoading = false;
        }
    }
    // pageSize 改变时会触发
    handleSizeChange(e) {
        this.page = 1;
        this.size = e;
        this.search();
    }
    // currentPage 改变时会触发
    handleCurrentChange(e) {
        this.page = e;
        this.search();
    }
    // 格式化时间
    formatDate(item) {
        // console.log(item);
        const time = item.captureTime;
        return moment(new Date(time)).format('yyyy-MM-DD HH:mm:ss');
    }
    handleDialog() {
        this.fullSkDialogVisible = true;
    }
    getScreenNum() {
        let num = 0;
        if (this.form.vehicleLibNames.length > 0) {
            num++;
        }
        if (this.form.parkingLotNames.length > 0) {
            num++;
        }
        if (this.form.dates && this.form.dates[0] && this.form.dates[1]) {
            num++;
        }
        return num;
    }
};
__decorate([
    Watch('$i18n.locale')
], default_1.prototype, "initI18n", null);
default_1 = __decorate([
    Component({
        name: 'carPortrait',
        components: {
            AuthNewitem,
            exportButton,
            CombinedPicture,
            BlurPicture,
            SecondaryVerification,
            datePicker,
            InputSearch,
        },
        i18n: {
            messages: {
                'en-us': {
                    picture: 'Picture',
                    plateNumber: 'Plate Number',
                    brand: 'Brand',
                    type: 'Vehicle type',
                    color: 'color',
                    vehicleLibrary: 'Vehicle Library',
                    parkingLot: 'Parking Lot',
                    flowDirection: 'Flow Direction',
                    deviceSn: 'Serial-number',
                    captureTime: 'Capture Time',
                    deviceName: 'Device Name',
                    reset: 'Reset',
                    cancel: 'Cancel',
                    confirm: 'Confirm',
                    in: 'In',
                    out: 'Out',
                    keywordPlaceholder: 'Plate Number',
                    total: 'Total {msg} Items',
                    vehicleLibNames: 'Vehicle Library Name',
                    parkingLotName: 'Parking Lot Name',
                },
                zh: {
                    picture: '图片',
                    plateNumber: '车牌号码',
                    brand: '品牌',
                    type: '车辆类型',
                    color: '颜色',
                    vehicleLibrary: '车辆库',
                    parkingLot: '停车场名称',
                    flowDirection: '车流方向',
                    deviceName: '设备名称',
                    deviceSn: '设备序列号',
                    captureTime: '抓拍时间',
                    reset: '重置',
                    cancel: '取消',
                    confirm: '确认',
                    in: '驶入',
                    out: '驶出',
                    keywordPlaceholder: '车牌号',
                    total: '总共 {msg} 条',
                    vehicleLibNames: '车辆库名称',
                    parkingLotName: '停车场名称',
                },
            },
            sharedMessages: typo.messages,
        },
    })
], default_1);
export default default_1;
